// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"bf1496b7","260":"85eabad6","450":"9314e562","511":"e57ae850","905":"e4d0b568"}[chunkId] + ".chunk.js";
};